﻿import { createFileRoute } from "@tanstack/react-router";
import { MsgMensagensLeiturasPage } from "@/paginas/pg_msg/msg-mensagens-leituras";

export const Route = createFileRoute("/_authenticated/msg-mensagens-leituras")({
  head: () => ({
    meta: [
      { title: "Status de mensagens — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Resumo por usuário das mensagens lidas e pendentes: conversas da equipe, avisos do assistente e recados do mural.",
      },
      { property: "og:title", content: "Status de mensagens — Milky Moo Palmares" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: MsgMensagensLeiturasPage,
});
